import './setupResizeObserverErrorSuppression';
import './setupAxios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {getOrCreateAnonymousUid} from './utils/anonymousUid';
import {applyAuthReturnPathBeforeRender} from './utils/authReturnPath';

getOrCreateAnonymousUid();
applyAuthReturnPathBeforeRender();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);